import {useSession} from '@/contexts/SessionContext';

/**
 * Custom hook for accessing session ID with a simplified API
 * @returns Object containing sessionId and utility functions
 */
function useSessionId() {
  const {state, setSessionId, clearSessionId, generateSessionId} = useSession();

  return {
    sessionId: state.sessionId,
    isInitialized: state.isInitialized,
    setSessionId,
    clearSessionId,
    generateSessionId,
  };
}

export default useSessionId;
